<template>
	<layout-page title="Start">
		<!-- title -->
		<div
			class="bg-green px-4 sm:px-6 py-4 lg:rounded-tl-2xl xl:rounded-t-2xl flex justify-start items-center"
		>
			<h1 class="text-2xl md:text-4xl font-semibold text-white">
				Willkommen {{ user.name }}!
			</h1>
		</div>

		<div class="px-4 sm:px-6 lg:px-6 py-6 bg-gray-100 flex flex-col space-y-2">
			<h2 class="py-4 text-2xl md:text-4xl font-semibold">Aktuelles</h2>

			<div class="flex py-4 gap-y-6 gap-x-6 flex-wrap md:flex-nowrap">

				<!-- CTA Premium -->
				<div
					class="flex border-transparent ring-2 ring-orange-500 hover:ring-orange-600 relative bg-white border rounded-lg shadow-sm flex focus:outline-none basis-0 max-w-1/2 flex-shrink-0 flex-grow min-w-44% sm:min-w-24 overflow-hidden"
				>
					<page-link
						class="w-full min-h-24 lg:min-h-28 text-orange hover:text-gray-500 font-semibold flex items-center justify-around p-3 sm:px-4 sm:py-4 md:px-2 md:py-3 lg:px-3 hover:text-orange-600 hover:bg-orange-100"
						:href="$route('premium.index')"
						:absolute="true"
					>
						<img class="px-3" src="/images/Logo_cropspot_PLUS_orange.svg">
					</page-link>
				</div>

				<!-- CTA Inserat erstellen -->
				<div
					class="flex border-transparent ring-2 ring-orange-500 hover:ring-orange-600 relative bg-white border rounded-lg shadow-sm flex focus:outline-none basis-0 max-w-1/2 flex-shrink-0 flex-grow min-w-44% sm:min-w-24 overflow-hidden"
				>
					<a
						class="w-full min-h-24 lg:min-h-28 text-orange font-semibold flex items-center justify-around p-3 sm:px-4 sm:py-4 md:px-2 md:py-3 lg:px-3 hover:text-orange-600 hover:bg-orange-100"
						href="#"
						v-on:click="
							$bus.$emit('toggle-iframe-modal', $route('offers.create'), false, false)
						"
					>
						<span
							class="max-w-[52%] hyphens-auto"
							:lang="user.preferred_language"
						>Inserat erstellen</span
						>
						<span class="text-center">
							<font-awesome-icon
								icon="fas fa-circle-plus"
								class="text-3xl sm:text-4xl md:text-3xl lg:text-4xl"
							/>
						</span>
					</a>
				</div>

				<!-- CTA Auktion -->
				<div
					class="flex border-transparent ring-2 ring-orange-500 hover:ring-orange-600 relative bg-white border rounded-lg shadow-sm flex focus:outline-none basis-0 max-w-1/2 flex-shrink-0 flex-grow min-w-44% sm:min-w-24"
				>
					<page-link
						v-if="
							user.can_auction && user.acl.auction_edit && ctaAuctionIsIntake
						"
						:href="$route('offer_all.index')"
						:absolute="true"
						class="w-full min-h-24 lg:min-h-28 text-orange font-semibold flex items-center justify-around p-3 sm:px-4 sm:py-4 md:px-2 md:py-3 lg:px-3 hover:text-orange-600 hover:bg-orange-100"
					>
						<span
							class="max-w-[52%] hyphens-auto"
							:lang="user.preferred_language"
						>
							An Auktion teilnehmen
						</span>
						<span class="text-center">
							<ui-icon
								classes="text-3xl sm:text-4xl md:text-3xl lg:text-4xl"
								name="hammer"
								stroke-width="2"
							/>
						</span>
					</page-link>

					<a
						v-on:click="
							$bus.$emit('modal:open', {
								view: {
									view: 'views/Modal/Auction',
								}
							})
						"
						v-else
						class="w-full min-h-24 lg:min-h-28 text-orange font-semibold flex items-center justify-around p-3 sm:px-4 sm:py-4 md:px-2 md:py-3 lg:px-3 cursor-pointer hover:text-orange-600 hover:bg-orange-100"
					>
						<span
							class="max-w-[52%] hyphens-auto"
							:lang="user.preferred_language"
						>
							Infos zur Auktion
						</span>
						<span class="text-center">
							<ui-icon
								classes="text-3xl sm:text-4xl md:text-3xl lg:text-4xl"
								name="hammer"
								stroke-width="2"
							/>
						</span>
					</a>
				</div>

				<!-- CTA Externen Kontrakt erstellen -->
				<div
					v-if="this.acl['contracts.read']"
					class="flex border-transparent ring-2 ring-orange-500 hover:ring-orange-600 relative bg-white border rounded-lg shadow-sm flex focus:outline-none basis-0 max-w-1/2 flex-shrink-0 flex-grow min-w-44% sm:min-w-24"
				>
					<a
						class="w-full min-h-24 lg:min-h-28 text-orange font-semibold flex items-center justify-around p-3 sm:px-4 sm:py-4 md:px-2 md:py-3 lg:px-3 hover:text-orange-600 hover:bg-orange-100"
						href="#"
						v-on:click="
							$bus.$emit(
								'toggle-iframe-modal',
								$route('external_contract.create')
							)
						"
					>
						<span
							class="max-w-[52%] hyphens-auto"
							:lang="user.preferred_language"
							>Externen Kontrakt hinzufügen</span
						>
						<span class="text-center">
							<font-awesome-icon
								icon="fas fa-file-circle-plus"
								class="text-3xl sm:text-4xl md:text-3xl lg:text-4xl"
							/>
						</span>
					</a>
				</div>

				<!-- CTA Marktkompass -->
				<div
					v-else
					class="flex border-transparent ring-2 ring-orange-500 hover:ring-orange-600 relative bg-white border rounded-lg shadow-sm focus:outline-none basis-0 flex-grow sm:m-w-24"
				>
					<page-link
						class="w-full min-h-24 lg:min-h-28 text-orange hover:text-gray-500 font-semibold flex items-center justify-around p-3 sm:px-4 sm:py-4 md:px-2 md:py-3 lg:px-3 hover:text-orange-600 hover:bg-orange-100"
						:href="$route('content.compass')"
						tag="marktkompass"
						:cta="{
							code: 402,
							view: 'views/Modal/PremiumRequired'
						}"
						:absolute="true"
					>
						<span
							class="max-w-[52%] hyphens-auto"
							:lang="user.preferred_language"
							>Markt&shy;kompass lesen</span
						>
						<span class="text-center">
							<font-awesome-icon
								icon="fa-regular fa-chart-line-up"
								class="text-3xl sm:text-4xl md:text-3xl lg:text-4xl"
							/>
						</span>
					</page-link>
				</div>

				<!-- CTA SVM -->
				<div
					class="flex border-transparent ring-2 ring-orange-500 hover:ring-orange-600 relative bg-white border rounded-lg shadow-sm flex focus:outline-none basis-0 flex-shrink-0 flex-grow min-w-44% sm:min-w-24 hidden lg:flex"
				>
					<a
						class="w-full min-h-24 lg:min-h-28 text-orange font-semibold flex items-center justify-around p-3 sm:px-4 sm:py-4 md:px-2 md:py-3 lg:px-3 lg:py-4 hover:text-orange-600 hover:bg-orange-100"
						target="_blank"
						v-bind:href="'https://join.cropspot.com/staffelvermarktung'"
					>
						<span
							class="hyphens-auto max-w-[52%]"
							:lang="user.preferred_language"
							>Infos zur Staffel&shy;vermarktung</span
						>
						<span class="text-center">
							<font-awesome-icon
								icon="fas fa-circle-euro"
								class="text-3xl sm:text-4xl md:text-3xl lg:text-4xl"
							/>
						</span>
					</a>
				</div>
			</div>
		</div>
		<!-- Ende Aktuelles -->

		<!-- Frei-Fuhre-Preise -->
		<template v-if="acl['local_prices.chart']">
			<div class="bg-green px-4 sm:px-6 py-4 flex justify-start items-center">
				<h1 class="text-2xl md:text-4xl font-semibold text-white">
					{{ __("Price level development in your region") }}
				</h1>
			</div>

			<div class="px-4 sm:px-6 lg:px-6 py-6">
				<dashboard-price-chart />
			</div>
		</template>
		<!-- Ende Frei-Fuhre-Preise -->

		<!-- No Entries yet -->
		<div v-if="!hasSaleIntentions">
			<div class="bg-green px-4 sm:px-6 py-4 flex justify-start items-center">
				<h1 class="text-2xl md:text-4xl font-semibold text-white">
					Vermarktungsübersicht einrichten!
				</h1>
			</div>

			<div class="px-4 sm:px-6 lg:px-6 py-6 flex-grow flex flex-col space-y-2">
				<div
					class="rounded-xl my-5 py-6 px-6 lg:px-4 pt-2 pb-4 lg:pb-4 shadow ring-green-500 bg-white text-lg"
				>
					<div class="mx-auto px-4 sm:px-4 lg:py-6">
						<p class="my-5 font-semibold">
							Sie wollen eine kompakte Übersicht zum Verkaufsstatus Ihrer
							aktuellen Ernte?
						</p>

						<p class="mt-5 font-semibold">Wir haben die Lösung!</p>
						<p>
							cropspot fasst für Sie alle relevanten Informationen Ihrer
							Vermarktung in einer individuellen Darstellung zusammen!
						</p>

						<p class="my-5 font-semibold">So geht’s:</p>

						<ol class="list-inside list-decimal mt-5">
							<li class="py-1">
								In 10 Minuten legen Sie für jedes Ernteprodukt je Erntejahr Ihre
								Vermarktungsmenge fest.
							</li>
							<li class="py-1">
								Umgehend wird ermittelt, welche Mengen Sie bereits über cropspot
								verkauft haben.
							</li>
							<li class="py-1">
								Sie haben Ihre Ernte nicht über cropspot verkauft? Einfach
								nachpflegen!
							</li>
							<li class="py-1">
								Fertig! Ab jetzt haben Sie den schnellsten Überblick über Ihre
								Vermarktung!
							</li>
						</ol>

						<div class="flex justify-center my-10">
							<ui-button
								class="px-6 py-3"
								v-on:click="
									$bus.$emit('modal:open', {
										view: {
											dataUrl: $route('sale_intentions.update'),
											view: 'views/SaleIntention/Form',
											data: { product__harvest: ctaTargetHarvestYear }
										},
										cta: {
											code: 402,
											view: 'views/Modal/PremiumRequired'
										}
									})
								"
							>
								{{ __("Jetzt Planung starten!") }}
							</ui-button>
						</div>
					</div>
				</div>

				<div
					class="rounded-xl my-5 py-6 px-6 lg:px-4 pt-2 pb-4 lg:pb-4 shadow ring-green-500 bg-white text-lg"
				>
					<!-- py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24 -->
					<div class="mx-auto pt-4 pb-8 lg:py-8 px-4 sm:px-6">
						<p class="my-5 font-semibold">
							Weitere Fragen? Kontaktieren Sie uns und wir unterstützen Sie gern
							bei Ihrer Vermarktung!
						</p>

						<div class="flex items-center space-x-4 lg:space-x-6">
							<img
								class="w-16 h-16 rounded-full lg:w-20 lg:h-20"
								:src="contactPersonUrl"
								alt
							/>
							<div class="font-medium leading-6 space-y-1">
								<h3 class="text-gray-900 text-lg">Tobias Fallmeier</h3>
								<p class="text-gray-700">+49 (0) 172 1011 633</p>
								<a
									href="mailto:t.fallmeier@cropspot.com"
									class="text-orange-500"
									>t.fallmeier@cropspot.com</a
								>
							</div>
						</div>
					</div>
				</div>

				<Table
					:saleIntentions="filtered(mockedSaleIntentions, currentHarvestYear)"
					:year="currentHarvestYear"
					:disabled="true"
				/>

				<Table
					:saleIntentions="filtered(mockedSaleIntentions, secondHarvestYear)"
					:year="secondHarvestYear"
					:disabled="true"
				/>
			</div>
		</div>

		<div v-else>
			<div class="bg-green px-4 sm:px-6 py-4 flex justify-start items-center">
				<h1 class="text-2xl md:text-4xl font-semibold text-white">
					Ihr Vermarktungsstatus
				</h1>
			</div>

			<Table
				:saleIntentions="filtered(computedSaleIntentions, currentHarvestYear)"
				:year="currentHarvestYear"
				class="px-4 lg:px-6"
			/>

			<Table
				:saleIntentions="filtered(computedSaleIntentions, secondHarvestYear)"
				:year="secondHarvestYear"
				class="px-4 lg:px-6"
			/>
		</div>
	</layout-page>
</template>

<script>
import axios from "axios";
import Table from "../SaleIntention/Table.vue";

export default {
	name: "Dashboard",
	components: {
		Table,
	},
	props: {
		user: {
			type: Object,
			required: true,
		},
		premiumReminder: {
			type: Boolean,
			required: true,
			default: false
		},
		currentHarvestYear: {
			required: true,
			type: Number,
		},
		secondHarvestYear: {
			required: true,
			type: Number,
		},
		ctaTargetHarvestYear: {
			required: true,
			type: Number,
		},
		ctaAuctionIsIntake: {
			required: true,
			type: Boolean,
		},
		saleIntentions: {
			type: Object,
			required: false,
			default: () => {},
		},
		mockedSaleIntentions: {
			type: Object,
			required: false,
			default: () => {},
		},
		rendered: {
			type: String,
			required: true,
		},
	},
	computed: {
		contactPersonUrl: () => window.baseUrl + "/images/tobi-rounded.jpg",
		computedSaleIntentions() {
			return this.fetchedSaleIntentions ?? this.saleIntentions ?? {};
		},
		hasSaleIntentions() {
			const data = this.computedSaleIntentions;

			return Object.values(data).some(arr => Array.isArray(arr) && arr.length > 0);
		},
		computedPriceConfirmedAt() {
			return this.priceConfirmedAt ?? this.rendered;
		},
	},
	data() {
		return {
			acl: this.$inertia.page.props.acl,
			fetchedSaleIntentions: null,
			interval: null,
			delay: 1000 * 50,
			priceConfirmedAt: null,
		};
	},
	mounted() {
		this.$bus.$on("content:load", this.loadContent);

		if(this.hasSaleIntentions) {
			this.interval = setInterval(this.watchContentUpdates, this.delay);
		}

		if(this.premiumReminder){
			this.$bus.$emit('modal:open', {
				view: {
					view: 'views/Modal/PremiumReminder',
				}
			})
		}
	},
	watch: {
		hasSaleIntentions(newVal) {
			if (newVal && !this.interval) {
				this.interval = setInterval(this.watchContentUpdates, this.delay);
			}

			if (!newVal) {
				this.clearInterval();
			}
		}
	},
	beforeDestroy() {
		this.$bus.$off("content:load", this.loadContent);
		this.clearInterval();
	},
	methods: {
		filtered(saleIntentions, harvestYear) {
			return saleIntentions[harvestYear] ?? [];
		},
		loadContent() {
			axios.post(this.$route("sale_intentions.content", { id: this.user.id }))
				.then(this.onSuccess)
				.catch(this.onError);
		},
		onSuccess(result) {
			this.fetchedSaleIntentions = result.data.saleIntentions;
		},
		onError(error) {
			this.clearInterval();
			// todo fehlermeldung anzeigen
		},
		watchContentUpdates() {
				axios.post(this.$route("sale_intentions.content.updates", {id: this.user.id}))
				.then(this.evaluateReloadContent);
		},
		evaluateReloadContent(result) {
			if (result.data.price_confirmed_at > this.computedPriceConfirmedAt) {
				this.loadContent();
				this.priceConfirmedAt = result.data.price_confirmed_at;
			}
		},
		clearInterval() {
			if (this.interval) {
				clearInterval(this.interval);
				this.interval = null;
			}
		},
	},
};
</script>

<style scoped>
.hyphens-auto {
	-webkit-hyphens: auto;
	-ms-hyphens: auto;
	hyphens: auto;
}
</style>
